import { useQuery } from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { ResponseDto, StepUpStatusResponseDto } from "@mimber/schema"
import { accountKeys } from "../account.utils"
import type {
  UseStepUpStatusReturn,
  UseStepUpStatusOptions,
} from "./useStepUpStatus.types"

export const useStepUpStatus = (
  options?: UseStepUpStatusOptions
): UseStepUpStatusReturn => {
  guardAppUsage("mimber-organization", "useStepUpStatus")

  const { server } = useServerContext()

  return useQuery({
    queryKey: accountKeys.getStepUpStatus(),
    queryFn: async () => {
      const response = await server.get<ResponseDto<StepUpStatusResponseDto>>(
        "account/mfa/step-up/status"
      )
      return response.data
    },
    ...options,
  })
}
